module.exports = "/images/vendor/desiigner-svg/svg/ui/faux-checked.svg?8c588a7fcf381058ce47729b3bcecc0b";